import './Operations.css';
import { IonIcon, IonItem, IonLabel, IonNote, IonText, IonThumbnail } from "@ionic/react";
import { addOutline, giftOutline, phoneLandscape, phoneLandscapeOutline, phonePortraitOutline, removeOutline } from "ionicons/icons";
import moment from "moment";
import { Asset, DisplayableOperation } from "../../types/types";
import NumberFormat from "react-number-format";
import { useTranslation } from 'react-i18next';
import { capitalizeFirstLetter } from '../../services/utils/capitalizeFirst';
import { IconContext } from "react-icons";
import { AiOutlineBank } from "react-icons/ai";
import { SiStellar } from "react-icons/si";
import { HiOutlineReceiptRefund } from "react-icons/hi";



interface PaymentProps {
    operation: any;
    onClick: Function;
    asset: Asset
}

const PaymentListItem: React.FC<PaymentProps> = (props) => {

    const { t, i18n } = useTranslation();

    return (

        <IonItem lines='none' hidden={props.operation.hidden} className='operationsItem' onClick={() => { props.onClick() }}>

            {

                (props.operation.info && props.operation.info.kind === "giftcard") ?
                    <IonIcon slot='start' icon={giftOutline}></IonIcon>
                    :
                    (props.operation.info && props.operation.info.kind === "topup") ?
                        <IonIcon slot='start' icon={phonePortraitOutline}></IonIcon>
                        :
                        (props.operation.info && props.operation.info.kind === "bank_transfer") ?

                            <IonText slot='start'>
                                <IconContext.Provider value={{ size: "28px" }}>

                                    <AiOutlineBank />

                                </IconContext.Provider>
                            </IonText>
                            :
                            (props.operation.info && props.operation.info.kind === "refund") ?

                            <IonText slot='start'>
                                <IconContext.Provider value={{ size: "28px" }}>

                                    <HiOutlineReceiptRefund />

                                </IconContext.Provider>
                            </IonText>
                            :
                            (props.operation.info && props.operation.info.kind === 'lanave')?
                            
                            <IonThumbnail slot='start' className="operationsThumbnailIcon">
                                <img  src="/assets/img/lanave_outline.svg"/>
                            </IonThumbnail>
                            
                            :
                            <IonText slot='start'>
                                <IconContext.Provider value={{ size: "28px" }}>

                                    <SiStellar />

                                </IconContext.Provider>
                            </IonText>

            }

            <IonLabel>
                <IonText className="ion-text-wrap">
                    {
                        props.operation.name ?
                            (
                                <h5>
                                    {capitalizeFirstLetter(props.operation.name)}
                                </h5>
                            ) :
                            (props.operation.description) ?
                                (
                                    <h5>
                                        {capitalizeFirstLetter(props.operation.description)}
                                    </h5>
                                ) :
                                (props.operation.isRecipient) ?
                                    (
                                        <h5>
                                            {capitalizeFirstLetter(t('operations.payment.RECEIVE-LABEL') as string)}
                                        </h5>
                                    ) :
                                    (
                                        <h5>
                                            {capitalizeFirstLetter(t('operations.payment.SEND-LABEL') as string)}
                                        </h5>
                                    )

                    }

                </IonText>
                <IonNote className="operationsItem_IonNote">
                    {moment.unix(props.operation.timestamp).format("D MMM YYYY")}
                </IonNote>
            </IonLabel>

            <IonLabel slot='end' className='operationsItem_Amount'>

                <IonText color={props.operation.isRecipient ? 'primary' : "danger"} className="ion-text-wrap">

                    <h5>
                        <NumberFormat value={props.operation.amount.toString()}
                            prefix={props.operation.isRecipient ? "+ " : "- "}
                            displayType={'text'}
                            thousandSeparator={true}
                            decimalSeparator="."
                            decimalScale={props.asset.decimal_places}
                            fixedDecimalScale={true}
                            suffix={` ${props.asset.display_code}`}
                        />

                    </h5>

                </IonText>

            </IonLabel>

        </IonItem>
    );
};

export default PaymentListItem;